import { useToastStore } from "../store/toastStore";
import { useNotificationStore } from "../store/notificationStore";
import type { NotificationRecord } from "../store/notificationModalStore";
import { sanitize, getVariant, type BadgeVariant } from "../utils/notificationUtils";

interface WebSocketMessage {
  type?: string;
  payload?: {
    data?: {
      onNotificationPublished?: {
        requestId?: string;
        id?: string;
        title?: string;
        message?: string;
        priority?: string;
        timestamp?: string;
      };
    };
  };
  data?: { header?: string };
}

export const processNotificationMessage = (msg: WebSocketMessage | string): void => {
  const setToast = useToastStore.getState().setToast;
  const prependNotification = useNotificationStore.getState().prependNotification;

  let messageText = "";
  let headerText = "Notification";
  let variant: BadgeVariant = "info";
  let newNotification: NotificationRecord | null = null;

  if (typeof msg === "string") {
    messageText = sanitize(msg);
  } else if (msg && typeof msg === "object") {
    const payload = msg.payload?.data?.onNotificationPublished;
    messageText = sanitize(payload?.message);
    headerText = sanitize(payload?.title || msg.data?.header || "Notification");
    variant = getVariant(payload?.priority);

    newNotification = {
      ...payload,
      id: String(payload?.requestId || payload?.id || Date.now()),
      requestId: payload?.requestId,
      title: sanitize(payload?.title),
      message: sanitize(payload?.message),
      priority: payload?.priority,
      timestamp: payload?.timestamp || new Date().toISOString(),
      isRead: false,
    };
  }

  if (messageText) {
    setToast({ message: messageText, header: headerText, variant });
  }

  if (newNotification) {
    prependNotification(newNotification);
  }
};
